import Vue from "vue";
import Router from "vue-router";

// Containers
const DefaultContainer = () =>
  import("@/components/containers/DefaultContainer");

// Views
const Dashboard = () => import("@/views/base/dashboard/Dashboard");

// Example
const AllCharts = () => import("@/components/chart/chart");

// Views - Components
const Tables = () => import("@/views/base/tables/Tables");
const MapByState = () => import("@/views/base/map_overview/MapByState");
const BER = () =>
  import("@/views/base/technical_statistics/BeyondEconomicalRepair.vue");
const EOL = () => import("@/views/base/technical_statistics/EndOfLife.vue");
const WAR = () => import("@/views/base/technical_statistics/UnderWarranty.vue");
const Map = () => import("@/views/base/map_overview/MapOverview.vue");
const CityDashboard = () => import("@/views/base/dashboard/CityDashboard.vue");
const AnalyticsByModel = () =>
  import("@/views/base/technical_statistics/AnalyticsByModel.vue");
const ReceivedEquipment = () =>
  import("@/views/base/technical_statistics/ReceivedEquipment.vue");
const ModelDashboard = () => import("@/views/base/dashboard/ModelDashboard");
const BacklogByLocation = () =>
  import("@/views/base/backlog_by_location/BacklogByLocation");
const Profile = () => import("@/views/base/toolbar/ProfileSettings.vue");
const ActiveBacklog = () =>
  import("@/views/base/technical_statistics/ActiveBacklog.vue");
// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");

// Table All Data
const OverallData = () => import("@/views/base/overall_data/OverallData.vue");
const TableAllData = () => import("@/views/base/tables/TableAllData.vue");

// CompanyProfile
const CompanyProfile = () =>
  import("@/views/base/company_profile/CompanyProfile.vue");

// Issues
const IssuePreview = () => import("@/views/base/issues/IssuePreview.vue");
const IssueMap = () => import("@/views/base/issues/IssueMap.vue");

// Failure Data
const FailureDetails = () =>
  import("@/views/base/failure_details/FailureDetailsTable.vue");

const Search = () => import("@/views/base/search/Search.vue");

const SearchBySerial = () => import("@/views/base/search/SearchBySerial.vue");

Vue.use(Router);

export default new Router({
  mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: DefaultContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard
        },
        {
          path: "base/company-profile",
          name: "Company Profile",
          component: CompanyProfile,
          props(route) {
            return route.query || {};
          }
        },
        {
          path: "/failure-details",
          name: "Failure Details",
          component: FailureDetails,
          props(route) {
            return route.query || {};
          }
        },
        {
          path: "base/backlog-by-location",
          name: "Backlog By Location",
          component: BacklogByLocation
        },
        {
          path: "base/IssuesPreview",
          name: "Issues Preview",
          component: IssuePreview
        },
        {
          path: "base/IssuesMap",
          name: "Map By Region",
          component: IssueMap
        },
        {
          path: "AllCharts",
          name: "AllCharts",
          component: AllCharts
        },
        {
          path: "analyticsByModel",
          name: "AnalyticsByModel",
          component: AnalyticsByModel
        },
        {
          path: "activeBacklog",
          name: "ActiveBacklog",
          component: ActiveBacklog
        },
        {
          path: "ReceivedEquipment",
          name: "Received Equipment",
          component: ReceivedEquipment
        },

        {
          path: "base/overall",
          name: "Overall Data",
          component: OverallData
        },
        {
          path: "model",
          name: "ModelDashboard",
          component: ModelDashboard,
          props(route) {
            return route.query || {};
          }
        },
        {
          path: "base",
          redirect: "/base/cards",
          name: "Base",
          component: {
            render(c) {
              return c("router-view");
            }
          },
          children: [
            {
              path: "profile",
              name: "Profile Settings",
              component: Profile
            },
            {
              path: "BER",
              name: "BER",
              component: BER
            },
            {
              path: "EOL",
              name: "EOL",
              component: EOL
            },
            {
              path: "WAR",
              name: "WAR",
              component: WAR
            },
            {
              path: "Map",
              name: "Map Overview",
              component: Map
            },
            {
              path: "tables",
              name: "Tables",
              component: Tables,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "TableAllData",
              name: "TableAllData",
              component: TableAllData,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "city",
              name: "CityDashboard",
              component: CityDashboard,
              props(route) {
                return route.query || {};
              }
            },
            {
              path: "MapByState",
              name: "MapByState",
              component: MapByState,
              props(route) {
                return route.query || {};
              }
            },
            {
             path: "search-serial",
             name: "Search by Serial",
             component: SearchBySerial,
             props(route) {
               return route.query || {};
            }
          }
          ]
        },
        {
          path: "search",
          name: "Search Form",
          component: Search,
          props(route) {
            return route.query || {};
          }
        }
      ]
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404
        },
        {
          path: "500",
          name: "Page500",
          component: Page500
        },
        {
          path: "login",
          name: "Login",
          component: Login,
          props(route) {
            return route.query || {};
          }
        }
      ]
    }
  ]
});
